import * as z from "zod";
//#region src/__generated__/notification/internal/zod/deleteByScopeSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteByScopeQueryScopeSchema = z.enum([
	"READ",
	"UNREAD",
	"ALL"
]);
const deleteByScopeStatus204Schema = z.unknown();
const deleteByScopeResponseSchema = deleteByScopeStatus204Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/deleteOneSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteOnePathNotificationIdSchema = z.uuid();
const deleteOneStatus204Schema = z.unknown();
const deleteOneResponseSchema = deleteOneStatus204Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/notificationSettingsDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const notificationSettingsDtoSchema = z.object({ emailEnabled: z.boolean().describe("Получать уведомления по email") }).describe("Настройка получения уведомлений по электронной почте");
//#endregion
//#region src/__generated__/notification/internal/zod/getSettingsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getSettingsStatus200Schema = notificationSettingsDtoSchema.describe("Настройка получения уведомлений по электронной почте");
const getSettingsResponseSchema = getSettingsStatus200Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/webSocketNotificationDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const webSocketNotificationDtoSchema = z.object({
	eventType: z.enum([
		"APPLICATION_SUBMITTED",
		"APPROVERS_ASSIGNED",
		"APPROVER_REVIEWED",
		"FINAL_DECISION",
		"EMAIL_CHANGE_OLD_EMAIL_NOTICE",
		"EMAIL_CHANGE_CONFIRMATION",
		"EMAIL_CHANGED"
	]).optional(),
	params: z.object({}).catchall(z.string()).nullish(),
	requestId: z.uuid().nullish()
});
//#endregion
//#region src/__generated__/notification/internal/zod/getUnreadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUnreadStatus200Schema = z.array(webSocketNotificationDtoSchema);
const getUnreadResponseSchema = getUnreadStatus200Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/unreadCountDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const unreadCountDtoSchema = z.object({ count: z.int().describe("Количество непрочитанных уведомлений") }).describe("Количество непрочитанных уведомлений");
//#endregion
//#region src/__generated__/notification/internal/zod/getUnreadCountSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getUnreadCountStatus200Schema = unreadCountDtoSchema.describe("Количество непрочитанных уведомлений");
const getUnreadCountResponseSchema = getUnreadCountStatus200Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/notificationDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const notificationDtoSchema = z.object({
	createdAt: z.iso.datetime().nullish().describe("Дата и время создания"),
	eventType: z.enum([
		"APPLICATION_SUBMITTED",
		"APPROVERS_ASSIGNED",
		"APPROVER_REVIEWED",
		"FINAL_DECISION",
		"EMAIL_CHANGE_OLD_EMAIL_NOTICE",
		"EMAIL_CHANGE_CONFIRMATION",
		"EMAIL_CHANGED"
	]).optional().describe("Тип события"),
	id: z.uuid().nullish().describe("Идентификатор уведомления"),
	params: z.object({}).catchall(z.string()).nullish().describe("Параметры события для текстового шаблона frontend"),
	read: z.boolean().nullish().describe("Признак прочтения"),
	requestId: z.uuid().nullish().describe("Идентификатор связанной заявки; маршрут строит frontend")
}).describe("Уведомление в панели пользователя");
//#endregion
//#region src/__generated__/notification/internal/zod/cursorPageDtoNotificationDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const cursorPageDtoNotificationDtoSchema = z.object({
	content: z.array(notificationDtoSchema).nullish().describe("Элементы страницы"),
	hasNext: z.boolean().nullish().describe("Признак наличия следующей страницы"),
	nextCursor: z.string().nullish().describe("Курсор для запроса следующей страницы (отсутствует, если страница последняя)")
}).describe("Страница результатов с курсорной пагинацией");
//#endregion
//#region src/__generated__/notification/internal/zod/listSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listQueryCursorSchema = z.string().optional();
const listQuerySizeSchema = z.int().optional();
const listStatus200Schema = cursorPageDtoNotificationDtoSchema.describe("Страница результатов с курсорной пагинацией");
const listResponseSchema = listStatus200Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/markAllReadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const markAllReadStatus204Schema = z.unknown();
const markAllReadResponseSchema = markAllReadStatus204Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/markReadSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const markReadPathNotificationIdSchema = z.uuid();
const markReadStatus204Schema = z.unknown();
const markReadResponseSchema = markReadStatus204Schema;
//#endregion
//#region src/__generated__/notification/internal/zod/notificationCreateDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const notificationCreateDtoSchema = z.object({
	eventType: z.enum([
		"APPLICATION_SUBMITTED",
		"APPROVERS_ASSIGNED",
		"APPROVER_REVIEWED",
		"FINAL_DECISION",
		"EMAIL_CHANGE_OLD_EMAIL_NOTICE",
		"EMAIL_CHANGE_CONFIRMATION",
		"EMAIL_CHANGED"
	]).describe("Тип события"),
	params: z.object({}).catchall(z.string()).describe("Параметры для подстановки в шаблон письма"),
	recipientEmails: z.array(z.string()).min(1).describe("Email-адреса получателей"),
	recipientUserIds: z.array(z.uuid()).optional().describe("Keycloak UUID получателей для WS-уведомления (опционально)"),
	requestId: z.uuid().optional().describe("Идентификатор заявки (отсутствует у событий, не связанных с заявкой, напр. смена email)")
}).describe("Запрос на отправку уведомления");
//#endregion
//#region src/__generated__/notification/internal/zod/notifySchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const notifyStatus200Schema = z.unknown();
const notifyResponseSchema = notifyStatus200Schema;
const notifyDataSchema = notificationCreateDtoSchema.describe("Запрос на отправку уведомления");
//#endregion
//#region src/__generated__/notification/internal/zod/updateSettingsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateSettingsStatus204Schema = z.unknown();
const updateSettingsResponseSchema = updateSettingsStatus204Schema;
const updateSettingsDataSchema = notificationSettingsDtoSchema.describe("Настройка получения уведомлений по электронной почте");
//#endregion
export { deleteOneStatus204Schema as A, getUnreadStatus200Schema as C, notificationSettingsDtoSchema as D, getSettingsStatus200Schema as E, deleteByScopeResponseSchema as M, deleteByScopeStatus204Schema as N, deleteOnePathNotificationIdSchema as O, getUnreadResponseSchema as S, getSettingsResponseSchema as T, cursorPageDtoNotificationDtoSchema as _, notifyResponseSchema as a, getUnreadCountStatus200Schema as b, markReadPathNotificationIdSchema as c, markAllReadResponseSchema as d, markAllReadStatus204Schema as f, listStatus200Schema as g, listResponseSchema as h, notifyDataSchema as i, deleteByScopeQueryScopeSchema as j, deleteOneResponseSchema as k, markReadResponseSchema as l, listQuerySizeSchema as m, updateSettingsResponseSchema as n, notifyStatus200Schema as o, listQueryCursorSchema as p, updateSettingsStatus204Schema as r, notificationCreateDtoSchema as s, updateSettingsDataSchema as t, markReadStatus204Schema as u, notificationDtoSchema as v, webSocketNotificationDtoSchema as w, unreadCountDtoSchema as x, getUnreadCountResponseSchema as y };

//# sourceMappingURL=updateSettingsSchema2.js.map